module.exports = __webpack_public_path__ + "img/porto-10.edf5de67.png";